module.exports = __webpack_public_path__ + "static/media/stop-circle.673f75e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/stop-circle.svg
// module id = 774
// module chunks = 0